export enum LeadStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Disqualified = 'disqualified',
    SignedUp = 'signed-up',
    Churned = 'churned',
}
